/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Icon } from "@iconify/react";
import { Divider } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import "./Dashboard.css";
import ActivityDialog from "./ActivityDialog";
import BarChart_SaveResult from "./BarChart_SaveResult";
import BarChart_SolvedAssignment from "./BarChart_SolvedAssignment";
import ChannelDetailsDialog from "./ChannelDetailsDialog";
import PieChart_Conclude from "./PieChart_Conclude";
import { SeverityPill } from "./SeverityPill";
import StackBarChart_AgentStatistic from "./StackBarChart_AgentStatistic";
import Loader from "../Components/Loader";
import FacebookIcon from "../Images/facebook.svg";
import InstagramIcon from "../Images/InstagramIcon.svg";
import { ReactComponent as LegendACW } from "../Images/LegendACW.svg";
import { ReactComponent as LegendAUX } from "../Images/LegendAUX.svg";
import WhatsAppBusinessIcon from "../Images/WhatsappBusinessSession.svg";
import WhatsAppIcon from "../Images/logos_whatsapp-icon.svg";

import {
  getDataChat,
  getAgentState,
  getDataChatSolved,
  getChatAgent,
  getSummaryAgent,
  getSummaryResult,
  getSummarySolved,
  getDataCall,
  getDataTicket,
} from "../Store/Actions/DashboardAction";

import { getACDMonitoring } from "../Store/Actions/MonitoringAction";

export default function Dashboard({ changePage }) {
  const dispatch = useDispatch();
  const [statusCount, setStatusCount] = useState({});
  const [data, setData] = useState([]);
  const [callData, setCallData] = useState({});
  const [chatData, setChatData] = useState({});
  const [ticketData, setTicketData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isCallLoading, setIsCallLoading] = useState(true);
  const [isChatLoading, setIsChatLoading] = useState(true);
  const [isTicketLoading, setIsTicketLoading] = useState(true);
  const [isActivityDialogShown, setIsActivityDialogShown] = useState(false);
  const [isChannelDetailsDialogShown, setIsChannelDetailsDialogShown] =
    useState(false);
  const [selectedActivity, setSelectedActivity] = useState("");
  const [selectedChannel, setSelectedChannel] = useState(null);

  const {
    // chatCount,
    // agentState,
    chatSolved,
    chatAgent,
    // summaryAgent,
    summaryResult,
    summarySolved,
  } = useSelector((state) => state.dashboard);

  useEffect(() => {
    const fetchData = () => {
      getACDMonitoring(1)
        .then((response) => {
          if (response.status) {
            // console.log("ACD monitor data: ", response.data);
            setData(response.data);
            setStatusCount(countAgentStatus(response?.data?.acdagentDetail));
          } else {
            console.log("error", response.error);
          }

          setIsLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setIsLoading(false);
        });
    };

    // Fetch data on first render
    fetchData();

    // Fetch data every ten seconds
    const interval = setInterval(() => {
      fetchData();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchData = () => {
      // setIsCallLoading(true);
      getDataCall()
        .then((response) => {
          if (response.status) {
            console.log("Call data: ", response.data);
            setCallData(response.data);
          } else {
            console.log("error", response.error);
          }
          setIsCallLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setIsCallLoading(false);
        });
    };

    // Fetch data on first render
    fetchData();

    // Fetch data every ten seconds
    const interval = setInterval(() => {
      fetchData();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchData = () => {
      setIsChatLoading(true);
      setIsTicketLoading(true);
      getDataChat()
        .then((response) => {
          if (response.status) {
            console.log("Chat data: ", response.data);
            setChatData(response.data);
          } else {
            console.log("error", response.error);
          }
          setIsChatLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setIsChatLoading(false);
        });

      getDataTicket()
        .then((response) => {
          if (response.status) {
            console.log("Ticket data: ", response.data);
            setTicketData(response.data);
          } else {
            console.log("error", response.error);
          }
          setIsTicketLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setIsTicketLoading(false);
        });
    };
    // Fetch data on first render
    fetchData();

    // Fetch data every 30 second
    const interval = setInterval(() => {
      fetchData();
    }, 1000 * 30);

    return () => clearInterval(interval);
  }, []);

  const dataACDAgents = {
    labels: ["Ready", "Busy", "ACW", "AUX", "Not Bound"],

    datasets: [
      {
        data: Object.values(statusCount),

        backgroundColor: [
          "#00FF00",
          "#FF0000",
          "#FFE900",
          "#EE7314",
          "#727272",
        ],
      },
    ],
  };

  const optionsACDAgents = {
    maintainAspectRatio: false,
    responsive: true,

    plugins: {
      datalabels: {
        font: {
          size: 16,
          weight: 700,
        },

        color: (context) => {
          return context.dataset.backgroundColor[context.dataIndex] ===
            "#00FF00" ||
            context.dataset.backgroundColor[context.dataIndex] === "#FFE900"
            ? "#393939"
            : "#FFF";
        },

        display: (context) => context.dataset.data[context.dataIndex] > 0,

        formatter: (value) => {
          const filteredAgents = data?.acdagentDetail
            ? data.acdagentDetail.filter(
                (agent) => agent.CurrentState !== "LOGGEDOFF"
              )
            : [];

          const countPercentage = (value, total) =>
            Math.round((100 * value) / total);
          return countPercentage(value, filteredAgents.length) + "%";
        },
      },

      legend: {
        display: false,
      },
    },
  };

  const columnsACDAgents = [
    {
      field: "AgentName",
      flex: 1,
      headerName: "Agent Name",
    },

    {
      field: "CurrentState",
      flex: 1,
      headerName: "Status",
      minWidth: 135,

      renderCell: (params) => (
        <SeverityPill color={params.row.CurrentState.toLowerCase()}>
          {params.row.CurrentState}
        </SeverityPill>
      ),
    },

    {
      field: "Ext",
      flex: 1,
      headerName: "Ext",
    },

    {
      field: "AHT",
      flex: 1,
      headerName: "AHT",
      renderCell: (params) =>
        Math.round((params.row.AHT + Number.EPSILON) * 100) / 100,
    },

    {
      field: "CallsOffered",
      flex: 1,
      headerName: "Calls Offered",
    },

    {
      field: "CallsAnswered",
      flex: 1,
      headerName: "Calls Answered",
      minWidth: 140,
    },

    {
      field: "CallsAbandoned",
      flex: 1,
      headerName: "Abandoned",
    },

    {
      field: "CallsGhost",
      flex: 1,
      headerName: "Ghost Call",
    },
  ];

  const countAgentStatus = (data) => {
    const filteredAgents = data
      ? data.filter((agent) => agent.CurrentState !== "LOGGEDOFF")
      : [];

    const countStatus = (status) =>
      filteredAgents.reduce(
        (counter, obj) => (obj.CurrentState === status ? ++counter : counter),
        0
      );

    return {
      ready: countStatus("READY"),
      busy: countStatus("BUSY"),
      acw: countStatus("ACW"),
      aux: countStatus("AUX"),
      notBound: countStatus("NOT BOUND"),
    };
  };

  Chart.register(ChartDataLabels);

  let datalabels = {
    color: function (ctx) {
      var bgColor = ctx.dataset.backgroundColor[ctx.dataIndex];
      return bgColor === "#D9D9D9" || bgColor === "#aaaaaa" ? "black" : "white";
    },
    textShadowColor: function (ctx) {
      var bgColor = ctx.dataset.backgroundColor[ctx.dataIndex];
      return bgColor === "#D9D9D9" || bgColor === "#aaaaaa" ? "white" : "black";
    },
    textShadowBlur: 15,
    display: function (context) {
      return context.dataset.data[context.dataIndex] > 0;
    },
    font: {
      weight: "bold",
      size: 15,
    },
    formatter: Math.round,
  };

  // let getDataChatID = null;
  let getAgentStateID = null;
  let getDataChatSolvedID = null;
  let getChatAgentID = null;
  let getSummaryAgentID = null;
  let getSummaryResultID = null;
  let getSummarySolvedID = null;
  let interval = 1000 * 10;

  useEffect(() => {
    // clearInterval(getDataChatID);
    clearInterval(getAgentStateID);
    clearInterval(getDataChatSolvedID);
    clearInterval(getChatAgentID);
    clearInterval(getSummaryAgentID);
    clearInterval(getSummaryResultID);
    clearInterval(getSummarySolvedID);

    // dispatch(getDataChat());
    dispatch(getAgentState());
    dispatch(getDataChatSolved());
    dispatch(getChatAgent());
    dispatch(getSummaryAgent());
    dispatch(getSummaryResult());
    dispatch(getSummarySolved());

    // getDataChatID = setInterval(() => dispatch(getDataChat()), interval);
    getAgentStateID = setInterval(() => dispatch(getAgentState()), interval);
    getDataChatSolvedID = setInterval(
      () => dispatch(getDataChatSolved()),
      interval
    );
    getChatAgentID = setInterval(() => dispatch(getChatAgent()), interval);
    getSummaryAgentID = setInterval(
      () => dispatch(getSummaryAgent()),
      interval
    );
    getSummaryResultID = setInterval(
      () => dispatch(getSummaryResult()),
      interval
    );
    getSummarySolvedID = setInterval(
      () => dispatch(getSummarySolved()),
      interval
    );

    return () => {
      // clearInterval(getDataChatID);
      clearInterval(getAgentStateID);
      clearInterval(getDataChatSolvedID);
      clearInterval(getChatAgentID);
      clearInterval(getSummaryAgentID);
      clearInterval(getSummaryResultID);
      clearInterval(getSummarySolvedID);
    };
  }, []);

  const dummyChannelData = [
    {
      key: "Pending Chats",
      value: 26,
    },

    {
      key: "Ongoing Chats",
      value: 4,
    },

    {
      key: "Closed Chats",
      value: 12,
    },

    {
      key: "Agent Assigned",
      value: 2,
    },

    {
      key: "Total Chats",
      value: 42,
    },
  ];

  const dummyChannelList = [
    {
      channel: "WhatsApp",
      name: "Moxcal Teknologi 1",
      phoneNumber: "081384688487",
      icon: WhatsAppIcon,
    },

    {
      channel: "WhatsApp",
      name: "Moxcal Teknologi 2",
      phoneNumber: "081384688482",
      icon: WhatsAppIcon,
    },

    {
      channel: "WhatsApp Business",
      name: "Moxcal Teknologi 2",
      phoneNumber: "081384688482",
      icon: WhatsAppBusinessIcon,
    },

    {
      channel: "Facebook",
      name: "Moxcal Teknologi",
      phoneNumber: null,
      icon: FacebookIcon,
    },

    {
      channel: "Instagram",
      name: "Moxcal Teknologi",
      phoneNumber: null,
      icon: InstagramIcon,
    },
  ];

  return (
    <div className="Dashboard">
      <div className="list_header">
        <div className="list_headerLeft">
          <h1>Inbound</h1>
        </div>
      </div>

      {/* <div className="DashboardBody"> */}
      {/* <div className="ContainerDashboardScroll"> */}
      {/* <Box mt={1} ml={1} mr={2}> */}
      <div className="containerDashboard">
        {/* <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={3}>
                <Box>
                  <StatsCard
                    color="secondary.main"
                    icon="1"
                    title="Active Chats"
                    count={chatCount && chatCount.Active ? chatCount.Active : 0}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <Box>
                  <StatsCard
                    color="warning.main"
                    icon="2"
                    title="Unassigned"
                    count={
                      chatCount && chatCount.Unassign ? chatCount.Unassign : 0
                    }
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <Box>
                  <StatsCard
                    color="success.main"
                    icon="3"
                    title="Solved"
                    count={chatCount && chatCount.Closed ? chatCount.Closed : 0}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <Box>
                  <StatsCard
                    color="primary.main"
                    icon="4"
                    title="Total Chats"
                    TotalChat
                    count={
                      chatCount && chatCount.TotalChat ? chatCount.TotalChat : 0
                    }
                  />
                </Box>
              </Grid>
            </Grid>
            <Box mt={4} mb={1}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={4}>
                  <Box>
                    <Doughnut_AgentState
                      agentState={agentState}
                      datalabels={datalabels}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6} lg={8}>
                  <Box>
                    <ListContainer_SummaryAgent summaryAgent={summaryAgent} />
                  </Box>
                </Grid>
              </Grid>
            </Box> */}

        <div className="new-dashboard">
          <section className="cards">
            <div
              className="item calls"
              onClick={() => {
                setIsActivityDialogShown(true);
                setSelectedActivity("call");
              }}
            >
              <Icon className="icon" height="40" icon="material-symbols:call" />

              {isCallLoading ? (
                <Loader />
              ) : (
                <>
                  <div>
                    <p className="title">Active Calls</p>
                    <p className="value">{callData ? callData?.total?.TotalActive : 0}</p>
                  </div>

                  <div>
                    <p className="title">Total Calls</p>
                    <p className="value">{callData ? callData?.total?.TotalCalls : 0}</p>
                  </div>
                </>
              )}
            </div>

            <div
              className="item chats"
              onClick={() => {
                setIsActivityDialogShown(true);
                setSelectedActivity("chat");
              }}
            >
              <Icon className="icon" height="40" icon="mdi:message-group" />

              {isChatLoading ? (
                <Loader />
              ) : (
                <>
                  <div>
                    <p className="title">Active Chats</p>
                    <p className="value">{chatData.total.Active}</p>
                  </div>

                  <div>
                    <p className="title">Total Chats</p>
                    <p className="value">{chatData.total.TotalChat}</p>
                  </div>
                </>
              )}
            </div>

            <div
              className="item tickets"
              onClick={() => {
                setIsActivityDialogShown(true);
                setSelectedActivity("ticket");
              }}
            >
              <Icon className="icon" height="40" icon="iconamoon:ticket-fill" />

              {isTicketLoading ? (
                <Loader />
              ) : (
                <>
                  <div>
                    <p className="title">Active Tickets</p>
                    <p className="value">{ticketData ? ticketData?.total?.TotalActive : 0}</p>
                  </div>

                  <div>
                    <p className="title">Total Tickets</p>
                    <p className="value">{ticketData ? ticketData?.total?.TotalTicket : 0}</p>
                  </div>
                </>
              )}
            </div>
          </section>

          <section className="agents-detail">
            <div className="agents-chart">
              <header>
                <div className="title">
                  <Icon height="26" icon="pajamas:status-health" />
                  Online Status
                </div>

                <p className="count">
                  {
                    data?.acdagentDetail?.filter(
                      (agent) => agent.CurrentState !== "LOGGEDOFF"
                    ).length
                  }
                </p>
              </header>

              <div className="chart-container">
                <Doughnut
                  data={dataACDAgents}
                  options={optionsACDAgents}
                  plugins={[ChartDataLabels]}
                />
              </div>

              <div className="agents-chart-legend">
                <div className="ready">
                  <Icon
                    height="26"
                    icon="tabler:square-rounded-check"
                    width="26"
                  />

                  <span>Ready</span>
                  <span className="count">{statusCount.ready}</span>
                </div>

                <div className="busy">
                  <Icon
                    height="26"
                    icon="tabler:alert-square-rounded-filled"
                    width="26"
                  />

                  <span>Busy</span>
                  <span className="count">{statusCount.busy}</span>
                </div>

                <div className="acw">
                  <LegendACW />
                  <span>ACW</span>
                  <span className="count">{statusCount.acw}</span>
                </div>

                <div className="aux">
                  <LegendAUX />
                  <span>AUX</span>
                  <span className="count">{statusCount.aux}</span>
                </div>

                <div className="not-bound">
                  <Icon height="26" icon="tabler:square-rounded-x" width="26" />

                  <span>NotBound</span>
                  <span className="count">{statusCount.notBound}</span>
                </div>
              </div>
            </div>

            <div className="acd-agents">
              <header>
                <div className="title">
                  <Icon height="26" icon="ic:round-support-agent" width="26" />

                  <p>Agents Summary</p>
                </div>
              </header>

              <div className="table-container">
                <DataGrid
                  autoHeight
                  className="table"
                  columns={columnsACDAgents}
                  disableColumnFilter
                  disableColumnMenu
                  disableSelectionOnClick
                  hideFooter
                  loading={isLoading}
                  rows={
                    data?.acdagentDetail
                      ? data.acdagentDetail.filter(
                          (agent) => agent.CurrentState !== "LOGGEDOFF"
                        )
                      : []
                  }
                  getRowId={(row) => row.AgentName + "-" + row.Ext}
                />
              </div>
            </div>
          </section>

          {/* hide dulu sementara */}
          <section className="channel-list">
            <header>
              <div className="title">
                <Icon
                  height="26"
                  icon="fluent:bubble-multiple-20-filled"
                  width="26"
                />

                <p>Channel List</p>
              </div>
            </header>

            <div className="list-container">
              {dummyChannelList.map((channel, index) => (
                <div
                  // Get first word then change to lowercase
                  className={`channel-item ${channel.channel
                    .trim()
                    .split(/\s+/)[0]
                    .toLowerCase()}`}
                  key={index}
                >
                  <img
                    alt=""
                    src={channel.icon}
                    style={{ height: 28, width: 28 }}
                  />

                  <div className="channel-content">
                    <p className="channel-details">
                      {`${
                        channel.phoneNumber ? channel.phoneNumber + " - " : ""
                      }${channel.name}`}{" "}
                      <span>({channel.channel})</span>
                    </p>

                    <div className="channel-data">
                      {dummyChannelData.map((data, index) => (
                        <div className="channel-data-item" key={index}>
                          <p className="key">{data.key}</p>
                          <p className="value">{data.value}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <button
                    className="detail-button"
                    onClick={() => {
                      setSelectedChannel(channel);
                      setIsChannelDetailsDialogShown(true);
                    }}
                  >
                    <Icon className="icon" height="28" icon="bxs:user-detail" />
                    Detail
                  </button>
                </div>
              ))}
            </div>
          </section>

          <section className="agents-detail">
            <div className="item save-result">
              <header>
                <div className="title">Saved Result</div>
              </header>
              <Divider />
              <BarChart_SaveResult
                summaryResult={summaryResult}
                datalabels={datalabels}
              />
            </div>
          </section>

          <section className="agents-detail">
            <div className="item assignment-solved">
              <header>
                <div className="title">Assignment Solved</div>
              </header>
              <Divider />
              <BarChart_SolvedAssignment
                chatSolved={chatSolved}
                datalabels={datalabels}
              />
            </div>
            <div className="item solved-status">
              <header>
                <div className="title">Solved Status</div>
              </header>
              <Divider />
              <PieChart_Conclude
                summarySolved={summarySolved}
                datalabels={datalabels}
              />
            </div>
          </section>

          <section className="agents-detail">
            <div className="item save-result">
              <header>
                <div className="title">Agent Statistic</div>
              </header>
              <Divider />
              <StackBarChart_AgentStatistic
                chatAgent={chatAgent}
                datalabels={datalabels}
              />
            </div>
          </section>
        </div>
        {/* Saved Result */}
        {/* <Box mt={4} mb={1}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Box>
                <BarChart_SaveResult
                  summaryResult={summaryResult}
                  datalabels={datalabels}
                />
              </Box>
            </Grid>
          </Grid>
        </Box> */}
        {/* Assignment Solved & Solved Status*/}
        {/* <Box mt={4}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={8}>
              <Box>
                <BarChart_SolvedAssignment
                  chatSolved={chatSolved}
                  datalabels={datalabels}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Box mb={3}>
                <PieChart_Conclude
                  summarySolved={summarySolved}
                  datalabels={datalabels}
                />
              </Box>
            </Grid>
          </Grid>
        </Box> */}
        {/* AgentStatistic */}
        {/* <Box mt={4}>
          <Grid container spacing={3} mb={-6} mt={-6}>
            <Grid item xs={12} md={6} lg={6}>
              <Box mb={3}>
                <StackBarChart_AgentStatistic
                  chatAgent={chatAgent}
                  datalabels={datalabels}
                />
              </Box>
            </Grid>
          </Grid>
        </Box> */}
      </div>

      <ActivityDialog
        changePage={changePage}
        data={
          selectedActivity === "call"
            ? callData.data
            : selectedActivity === "chat"
            ? chatData.data
            : selectedActivity === "ticket"
            ? ticketData.data
            : null
        }
        isOpen={isActivityDialogShown}
        selectedActivity={selectedActivity}
        setIsActivityDialogShown={setIsActivityDialogShown}
      />

      <ChannelDetailsDialog
        isOpen={isChannelDetailsDialogShown}
        selectedChannel={selectedChannel}
        setIsChannelDetailsDialogShown={setIsChannelDetailsDialogShown}
        setSelectedChannel={setSelectedChannel}
      />
    </div>
  );
}
